import React, { Component } from 'react';
import './App.css';
import {Container, Divider, Header, Icon, Menu, Segment} from "semantic-ui-react"
import ProjectPage from "./containers/ProjectPage"

class App extends Component {
  render() {
    return (
      <div className="App">
        <Menu
          inverted
          stackable
          attached={true}
        >
          <Container>
            <Menu.Item>
              <Header as='h1' style={{color: '#fff'}}>nsch</Header>
            </Menu.Item>
            <Menu.Item active={true}>
              Portfolio
            </Menu.Item>
            <Menu.Menu position='right'>
              <Menu.Item>
                <Icon name='mail outline' />nick@nsch.nl
              </Menu.Item>
              <Menu.Item>
                <a href='https://github.com/nsch1'>
                  <Icon name='github' size='big' />
                </a>
              </Menu.Item>
              <Menu.Item>
                <a href='https://www.linkedin.com/in/nick-schooneman-348577152'>
                  <Icon name='linkedin' size='big' />
                </a>
              </Menu.Item>
            </Menu.Menu>
          </Container>
        </Menu>
        <Container style={{
          padding: '40px 20px 40px'
        }}>
          <Segment inverted style={{
            backgroundColor: 'rgba(0,0,0,0.6)'
          }}>
            <ProjectPage/>
            <Divider/>
            <p>
              <Icon name='mail outline'/> nick@nsch.nl
            </p>
            <Divider/>
            <p style={{color:'#727272',fontSize:'0.8rem'}}>
              © 2018 Nick Schooneman
            </p>
          </Segment>
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js